/*
 * ----------------------------------------------------------------------------
 * QUIZ POP-UP — controller de triggers (Fase 3)
 * ----------------------------------------------------------------------------
 * NAO redefine o pop-up: dirige o custom element <pop-in> ja registrado em
 * assets/theme.js (DialogElement -> abre/fecha/ESC/animacao/foco). Zero JS novo
 * no theme.js. Aqui ficam apenas os GATILHOS proprios do quiz-popup:
 *   - apparition-delay (segundos)
 *   - exit-intent (SO desktop / ponteiro fino)
 *   - only-once por sessao (localStorage)
 *
 * COEXISTENCIA com newsletter-popup (regra obrigatoria QPO-F3-3)
 * ------------------------------------------------------------------
 * Os dois pop-ups NUNCA disparam juntos. Compartilham as chaves do tema:
 *   - theme:popup-appeared  -> algum pop-up ja apareceu nesta sessao
 *   - theme:popup-filled    -> newsletter ja preenchido
 *
 * PRIORIDADE: newsletter-popup > quiz-popup.
 *   - Se ha um <newsletter-popup> elegivel na pagina, o quiz NAO dispara (nem
 *     agenda delay, nem liga exit-intent): o newsletter fica com a sessao.
 *   - Senao, o quiz pode disparar; re-checa no momento do disparo (corrige
 *     corridas) e marca theme:popup-appeared ao abrir, travando o outro.
 *
 * O resultado/somatorio/persistencia continua 100% em assets/quiz.js (a engine
 * dentro do pop-up e a MESMA da pagina).
 * ----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var APPEARED_KEY = 'theme:popup-appeared';
  var FILLED_KEY = 'theme:popup-filled';
  var READY_ATTR = 'data-quiz-popup-ready';

  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* noop */ }
  }

  // Exit-intent SO em desktop com ponteiro fino (mouse). Nunca em touch/mobile.
  function isDesktopPointer() {
    return !!(window.matchMedia && window.matchMedia('(min-width: 1000px) and (pointer: fine)').matches);
  }

  // Newsletter tem prioridade: ha um <newsletter-popup> que ainda vai/pode aparecer?
  function newsletterWillAppear() {
    var nl = document.querySelector('newsletter-popup');
    if (!nl) return false;
    if (lsGet(FILLED_KEY) === 'true') return false;
    if (nl.hasAttribute('only-once') && lsGet(APPEARED_KEY) === 'true') return false;
    return true;
  }

  function QuizPopup(el) {
    this.el = el;
    this.delay = (parseInt(el.getAttribute('data-apparition-delay'), 10) || 0) * 1000;
    this.onlyOnce = el.getAttribute('data-only-once') === 'true';
    this.exitIntent = el.getAttribute('data-exit-intent') === 'true';
    this.clickOnly = el.getAttribute('data-quiz-popup-trigger') === 'click';
    this.fired = false;
    this.exitBound = false;
    this.onMouseOut = this.onMouseOut.bind(this);
    this.init();
  }

  QuizPopup.prototype.eligible = function () {
    if (this.fired || this.el.open) return false;
    if (lsGet(FILLED_KEY) === 'true') return false;                   // newsletter ja preenchido
    if (this.onlyOnce && lsGet(APPEARED_KEY) === 'true') return false; // ja apareceu um pop-up
    if (newsletterWillAppear()) return false;                          // newsletter tem prioridade
    return true;
  };

  QuizPopup.prototype.appear = function () {
    if (!this.eligible()) return; // re-checa no disparo (corrige corrida com newsletter)
    this.fired = true;
    lsSet(APPEARED_KEY, 'true');  // marca antes de abrir -> bloqueia o outro nesta sessao
    this.teardownExitIntent();
    if (typeof this.el.show === 'function') {
      this.el.show();
    } else {
      this.el.setAttribute('open', '');
    }
  };

  QuizPopup.prototype.onMouseOut = function (e) {
    // cursor saindo pelo topo da viewport (relatedTarget nulo = saiu da janela)
    if (!e.relatedTarget && e.clientY <= 0) {
      this.appear();
    }
  };

  QuizPopup.prototype.setupExitIntent = function () {
    if (!this.exitIntent || !isDesktopPointer()) return;
    document.addEventListener('mouseout', this.onMouseOut);
    this.exitBound = true;
  };

  QuizPopup.prototype.teardownExitIntent = function () {
    if (this.exitBound) {
      document.removeEventListener('mouseout', this.onMouseOut);
      this.exitBound = false;
    }
  };

  QuizPopup.prototype.init = function () {
    var self = this;

    // No editor do tema NAO auto-dispara: o preview e controlado por
    // handle-editor-events (selecionar a section abre o pop-in).
    if (window.Shopify && window.Shopify.designMode) return;

    // click-only: sem gatilhos automaticos (abre so via [aria-controls="quiz-popup-modal"])
    if (this.clickOnly) return;

    if (!this.eligible()) return;

    window.setTimeout(function () { self.appear(); }, this.delay);
    this.setupExitIntent();
  };

  function initRoot(el) {
    if (!el || el.getAttribute(READY_ATTR) === 'true') return;
    el.setAttribute(READY_ATTR, 'true');
    try {
      new QuizPopup(el);
    } catch (err) {
      if (window.console) console.error('[quiz-popup] init failed:', err);
    }
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-quiz-popup]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-inicializa quando a section recarrega
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
